export default {
	click_event: "click_event",
};
